(function () {
  'use strict';

  var SWIPE_MIN_PX = 48;

  function normalizeGalleryItem(item) {
    if (typeof item === 'string' && item.trim() !== '') {
      return { src: item.trim(), srcset: '' };
    }
    if (item && typeof item === 'object' && typeof item.src === 'string' && item.src.trim() !== '') {
      return {
        src: item.src.trim(),
        srcset: typeof item.srcset === 'string' ? item.srcset : '',
      };
    }
    return null;
  }

  function parseGallery(article) {
    var raw = article.getAttribute('data-cw-gallery');
    if (!raw) {
      return [];
    }
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) {
        return [];
      }
      var out = [];
      for (var i = 0; i < parsed.length; i += 1) {
        var item = normalizeGalleryItem(parsed[i]);
        if (item) {
          out.push(item);
        }
      }
      return out;
    } catch (e) {
      return [];
    }
  }

  function applyImage(imgEl, src, srcset) {
    if (!imgEl || !src || imgEl.tagName !== 'IMG') {
      return;
    }
    var cur = imgEl.getAttribute('src') || '';
    var curSet = imgEl.getAttribute('srcset') || '';
    var nextSet = srcset || '';
    if (cur === src && curSet === nextSet) {
      return;
    }

    var pre = new Image();
    pre.decoding = 'async';
    var done = false;
    function commit() {
      if (done) {
        return;
      }
      done = true;
      imgEl.src = src;
      if (nextSet) {
        imgEl.setAttribute('srcset', nextSet);
      } else {
        imgEl.removeAttribute('srcset');
      }
    }
    pre.onload = commit;
    pre.onerror = commit;
    if (nextSet) {
      pre.srcset = nextSet;
    }
    pre.src = src;
    if (pre.complete) {
      commit();
    }
  }

  function prefetchUrl(src, srcset, sizes) {
    if (!src) {
      return;
    }
    var pre = new Image();
    if (srcset) {
      if (sizes) {
        pre.sizes = sizes;
      }
      pre.srcset = srcset;
    }
    pre.src = src;
  }

  function setNavState(article, index, len) {
    var nav = article.querySelector('[data-cw-card-nav]');
    if (!nav) {
      return;
    }
    var prev = nav.querySelector('[data-cw-card-prev]');
    var next = nav.querySelector('[data-cw-card-next]');
    if (!prev || !next) {
      return;
    }
    prev.disabled = index <= 0;
    prev.setAttribute('aria-disabled', index <= 0 ? 'true' : 'false');
    next.disabled = index >= len - 1;
    next.setAttribute('aria-disabled', index >= len - 1 ? 'true' : 'false');
  }

  function setActiveColorThumb(article, btn) {
    article.querySelectorAll('[data-cw-color-thumb]').forEach(function (el) {
      el.classList.toggle('is-active', el === btn);
    });
  }

  function syncCardLinks(article, productUrl) {
    if (!productUrl) {
      return;
    }
    article.querySelectorAll('.cw-product-card__media-link, .cw-product-card__meta').forEach(function (link) {
      link.href = productUrl;
    });
  }

  function bindColorThumbs(article, imgEl, state) {
    var thumbs = article.querySelectorAll('[data-cw-color-thumb]');
    if (!thumbs.length || !imgEl) {
      return;
    }

    var warmed = false;
    function warm() {
      if (warmed) {
        return;
      }
      warmed = true;
      var sz = imgEl.getAttribute('sizes') || '';
      thumbs.forEach(function (b) {
        prefetchUrl(b.getAttribute('data-image'), b.getAttribute('data-image-srcset') || '', sz);
      });
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      article.addEventListener(ev, warm, { passive: true, once: true });
    });

    thumbs.forEach(function (btn) {
      function preview() {
        var imageUrl = btn.getAttribute('data-image');
        var imageSrcset = btn.getAttribute('data-image-srcset') || '';
        var productUrl = btn.getAttribute('data-url');
        if (imageUrl) {
          state.colorPreviewUrl = imageUrl;
          state.colorPreviewSrcset = imageSrcset;
          state.index = 0;
          state.displayImage();
        }
        setActiveColorThumb(article, btn);
        syncCardLinks(article, productUrl);
      }

      btn.addEventListener('mouseenter', preview);
      btn.addEventListener('focus', preview);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var productUrl = btn.getAttribute('data-url');
        if (productUrl) {
          window.location.href = productUrl;
          return;
        }
        preview();
      });
    });

    var first = thumbs[0];
    if (first) {
      syncCardLinks(article, first.getAttribute('data-url'));
      var firstImage = first.getAttribute('data-image');
      if (firstImage) {
        state.colorPreviewUrl = firstImage;
        state.colorPreviewSrcset = first.getAttribute('data-image-srcset') || '';
        state.displayImage();
      }
    }

    article.addEventListener('mouseleave', function () {
      var active = article.querySelector('[data-cw-color-thumb].is-active');
      var url = active ? active.getAttribute('data-image') : '';
      if (url) {
        state.colorPreviewUrl = url;
        state.colorPreviewSrcset = active.getAttribute('data-image-srcset') || '';
      } else {
        state.colorPreviewUrl = '';
        state.colorPreviewSrcset = '';
      }
      state.index = 0;
      state.displayImage();
    });
  }

  function bindGalleryNav(article, state) {
    if (state.imgs.length < 2) {
      return;
    }

    var prev = article.querySelector('[data-cw-card-prev]');
    var next = article.querySelector('[data-cw-card-next]');
    var mediaLink = article.querySelector('.cw-product-card__media-link');
    var blockProductNavUntil = 0;

    function blockProductOpen() {
      blockProductNavUntil = Date.now() + 450;
    }

    function stop(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    function onNavActivate(e, delta) {
      stop(e);
      blockProductOpen();
      if (delta < 0 && state.index <= 0) {
        return;
      }
      if (delta > 0 && state.index >= state.imgs.length - 1) {
        return;
      }
      state.goTo(state.index + delta);
      blockProductOpen();
    }

    // pointerdown — łapie też szybkie kliknięcia, gdy strzałka zaraz się wyłączy
    [prev, next].forEach(function (btn, i) {
      if (!btn) {
        return;
      }
      var delta = i === 0 ? -1 : 1;
      btn.addEventListener('pointerdown', function (e) {
        if (e.button != null && e.button !== 0) {
          return;
        }
        onNavActivate(e, delta);
      });
      btn.addEventListener('click', function (e) {
        stop(e);
        blockProductOpen();
      });
    });

    if (mediaLink) {
      mediaLink.addEventListener(
        'click',
        function (e) {
          if (Date.now() < blockProductNavUntil) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }
  }

  function bindGallerySwipe(article, state) {
    if (state.imgs.length < 2) {
      return;
    }

    var media = article.querySelector('.cw-product-card__media');
    var mediaLink = article.querySelector('.cw-product-card__media-link');
    if (!media) {
      return;
    }

    var startX = 0;
    var startY = 0;
    var swipeBlockClick = false;

    media.addEventListener(
      'touchstart',
      function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) {
          return;
        }
        startX = e.changedTouches[0].clientX;
        startY = e.changedTouches[0].clientY;
      },
      { passive: true }
    );

    media.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) {
          return;
        }
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy)) {
          return;
        }
        swipeBlockClick = true;
        window.setTimeout(function () {
          swipeBlockClick = false;
        }, 400);
        if (dx < 0) {
          state.goTo(state.index + 1);
        } else {
          state.goTo(state.index - 1);
        }
      },
      { passive: true }
    );

    if (mediaLink) {
      mediaLink.addEventListener(
        'click',
        function (e) {
          if (swipeBlockClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }
  }

  function bindArticle(article) {
    if (article.getAttribute('data-cw-card-bound') === '1') {
      return;
    }
    article.setAttribute('data-cw-card-bound', '1');

    var imgs = parseGallery(article);
    var imgEl = article.querySelector('img.cw-product-card__img');
    var nav = article.querySelector('[data-cw-card-nav]');

    if (imgs.length < 2 && nav) {
      nav.remove();
    }

    var state = {
      imgs: imgs,
      index: 0,
      colorPreviewUrl: '',
      colorPreviewSrcset: '',
      displayImage: function () {},
      goTo: function () {}
    };

    var galleryWarmed = false;
    function warmGallery() {
      if (galleryWarmed) {
        return;
      }
      galleryWarmed = true;
      var sz = imgEl ? imgEl.getAttribute('sizes') || '' : '';
      imgs.forEach(function (item, i) {
        if (i > 0) {
          prefetchUrl(item.src, item.srcset, sz);
        }
      });
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      article.addEventListener(ev, warmGallery, { passive: true, once: true });
    });

    state.displayImage = function () {
      if (!imgEl) {
        return;
      }
      var src = '';
      var srcset = '';
      if (state.index === 0 && state.colorPreviewUrl) {
        src = state.colorPreviewUrl;
        srcset = state.colorPreviewSrcset || '';
      } else if (state.imgs[state.index]) {
        src = state.imgs[state.index].src;
        srcset = state.imgs[state.index].srcset || '';
      } else if (state.imgs[0]) {
        src = state.imgs[0].src;
        srcset = state.imgs[0].srcset || '';
        state.index = 0;
      }
      applyImage(imgEl, src, srcset);
      setNavState(article, state.index, state.imgs.length);
    };

    state.goTo = function (nextIndex) {
      if (state.imgs.length < 2) {
        return;
      }
      var next = Math.max(0, Math.min(state.imgs.length - 1, nextIndex));
      if (next === state.index) {
        return;
      }
      state.colorPreviewUrl = '';
      state.colorPreviewSrcset = '';
      state.index = next;
      state.displayImage();
    };

    if (imgEl) {
      bindColorThumbs(article, imgEl, state);
    }

    if (!imgEl || imgs.length < 2) {
      return;
    }

    setNavState(article, state.index, imgs.length);
    bindGalleryNav(article, state);
    bindGallerySwipe(article, state);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.cw-product-card').forEach(bindArticle);
    if (window.CustomWearFavorites && typeof window.CustomWearFavorites.syncWishButtons === 'function') {
      window.CustomWearFavorites.syncWishButtons(scope);
    }
  }

  window.CustomWearProductCard = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
